import {UpsellDialogEntryPoint} from '@Libraries/upsell-dialog.library';
import {convertFabricColorToFillObject} from '@Utils/color.util';
import {openCheckoutForCreditPackPurchase} from '@Modals/checkout-modal/checkout-modal.library';
import {getUserPremiumLevel, isUserLoggedIn, isUserPremium} from '@Libraries/user.library';
import {openMessageModal} from '@Modals/message-modal';
import {isMobile} from 'react-device-detect';
import {openResizeModal} from '@Modals/resize-modal';
import {openTableModal} from '@Modals/user-table-modal';
import type {TableItem} from '@PosterWhiteboard/items/table-item/table-item.class';
import {addScheduleToPoster} from '@PosterWhiteboard/items/table-item/table-item.class';
import {DEFAULT_COLUMNS, DEFAULT_ROWS, getDefaultScheduleData, getDefaultTableData, getScheduleData, getTableData} from '@PosterWhiteboard/items/table-item/user-table';
import {openScheduleModal} from '@Modals/user-schedule-modal/user-schedule-modal';
import {LayoutData} from '@PosterWhiteboard/items/table-item/table-item.types';
import type {MenuItem} from '@PosterWhiteboard/items/menu-item/menu-item.class';
import {addMenuToPoster} from '@PosterWhiteboard/items/menu-item/menu-item.class';
import {openUserMenuModal} from '@Modals/user-menu-modal';
import {getSelectedMenuItems} from '@PosterWhiteboard/items/menu-item/user-menu';
import {openFancytextModal} from '@Modals/fancytext-modal/fancytext-modal';
import type {AudioData, ElementData, ImageData, PMWExtractedGettyStickerData, PMWStillStickerData, TableData, TempImageData, VideoData} from '@Libraries/add-media-library';
import {ElementDataType, getGettyAssetClassification, isStickerElementType} from '@Libraries/add-media-library';
import type {VideoItem} from '@PosterWhiteboard/items/video-item/video-item.class';
import type {VideoSlideItem} from '@PosterWhiteboard/items/slideshow-item/slide-items/video-slide-item.class';
import {openTrimVideoModal} from '@Modals/trim-video-modal';
import {repoVideoURLForModel} from '@Libraries/user-video-library';
import type {TrimData} from '@Panels/trim-panels/trim-panels.types';
import {CollabOpenedSource, GA4EventName, GA4EventParamName, GA4EventSources, TimelineMediaAddOption, trackPosterBuilderGA4Events} from '@Libraries/ga-events';
import {trackTimelineMediaAdded} from '@Libraries/poster-editor-tracking.library';
import {TimelineItemType} from '@Components/poster-editor/components/timeline/timeline.types';
import {openTrimAudioModal} from '@Modals/trim-audio-modal';
import {getAudioUrl} from '@Libraries/user-audio-library';
import type {ImageItem} from '@PosterWhiteboard/items/image-item/image-item.class';
import type {ImageSlideItem} from '@PosterWhiteboard/items/slideshow-item/slide-items/image-slide-item.class';
import {onAddBrandAssetClickedHandler, removeVideoBackgroundFromId, removeVideoSlideBackgroundFromId} from '@Components/poster-editor/library/poster-editor-library';
import type {ItemData} from '@PosterWhiteboard/page/add-item.class';
import {loadImageAsync} from '@Utils/image.util';
import type {MaskingObject} from '@PosterWhiteboard/classes/masking/masking.types';
import {doesPublicFileExistAsync} from '@Utils/file.util';
import {getAssetUrl} from '@Utils/s3.util';
import {openMaskingModal} from '@Modals/masking-modal';
import {openColorBackgroundModal} from '@Modals/color-background-modal';
import type {BackgroundColorType} from '@Panels/color-background-panel/color-background-type.types';
import {BACKGROUND_TYPE, GRADIENT_TYPE} from '@Panels/color-background-panel/color-background-type.types';
import {FillTypes} from '@PosterWhiteboard/classes/fill.class';
import type {RGBA} from '@Utils/color.util';
import {hexToRgba, lightenDarkenColor, rgbaToHex} from '@Utils/color.util';
import {hideLoading, showLoading} from '@Libraries/loading-toast-library';
import {GettyAssetType, POSTER_GETTY_LIMIT} from '@PosterWhiteboard/poster/poster.types';
import {LayoutTypes} from '@PosterWhiteboard/items/layouts/layout.types';
import {DEFAULT_BACKGROUND_COLOR} from '@PosterWhiteboard/page/page.types';
import {openUserMediaModal} from '@Modals/user-media-modal';
import {UploadsMediaType} from '@Panels/user-media-panel/user-media-panel.types';
import type {CopyAndResizeData, ResizeModalPosterInformation} from '@Panels/resize-panel/resize-panel.types';
import type {StockModalProps} from '@Modals/stock-modal';
import {openStockMediaModal} from '@Modals/stock-modal';
import {closeStockMediaPopup, openStockMediaPopup} from '@Components/poster-editor/components/poster-add-item-bar/components/stock-media-dropdown/stock-media-popup-controller';
import {
  RESUMABLE_STOCK_MEDIA_PANEL_ID,
  RESUMABLE_STOCK_MEDIA_TAB_ID,
  STOCK_MEDIA_VIA_BACKGROUND_PANEL_ID,
  STOCK_MEDIA_VIA_VIDEO_BACKGROUND_PANEL_ID,
} from '@Components/poster-editor/components/poster-add-item-bar/components/stock-media-dropdown/stock-media-dropdown.types';
import type {StockMediaPopupOverrides} from '@Components/poster-editor/components/poster-add-item-bar/components/stock-media-dropdown/stock-media-popup-controller';
import type {CanvasDropPosition} from '@Libraries/canvas-item-drag.library';
import {placeItemAtDropPosition} from '@Libraries/canvas-item-drag.library';
import {onReplaceShape} from '@PosterWhiteboard/page/replace-item.class';
import {openSplitUpsellModal} from '@Modals/split-upsell-modal/split-upsell-modal.library';
import type {SplitUpsellAction} from '@Panels/split-upsell-panel/split-upsell-panel.types';
import {isCurrentUserEligibleForFreeTrial} from '@Libraries/premium-library';
import {openPremiumPricingModal} from '@Modals/premium-pricing-modal/premium-pricing-modal.library';
import {GETTY_STOCK_CONTENT_UPSELL} from '@Panels/premium-pricing-panel/premium-pricing-panel.constants';
import {openPosterEditorLanguageModal} from '@Modals/poster-editor-language-modal';
import type {UserTableProps} from '@Panels/user-table-panel/user-table-panel';
import {AI_CAROUSEL_CONTENT_TYPES_ALL, AiCarouselContentType, StockButtonFilters, StockPanelTabs} from '@Panels/stock-panel/stock-panel.types';
import type {AiPanelKey} from '@Panels/stock-panel/components/stock-ai-button/stock-ai-button.types';
import type {MediaSourceLeaf, MediaSourceRequest, ReplaceAiPanelKey, ReplaceSourceSelection, ReplaceableMediaItem} from '@Components/media-source-menu/media-source-menu.types';
import {MediaSourceGroup, MediaSourceIntent, MediaSourceKind} from '@Components/media-source-menu/media-source-menu.types';
import {assertNever} from '@Utils/assert-never.util';
import type {BuyCreditsResponse} from '@/types/credits.types';
import {openSettingsModal} from '@Modals/settings-modal';
import {openConfirmRemoveVideoBackgroundModal} from '@Modals/confirm-remove-video-background-modal';
import {refreshTeamCreditsInStore} from '@Components/team-credits/team-credits-library';
import {updateFeatureDemo, updateWebDownloadPanelOpenState} from '@Components/poster-editor/poster-editor-reducer';
import {FeatureDemo} from '@Components/poster-editor/poster-editor.types';
import {isPremiumUser} from '@Utils/user.util';
import {openResumableStockMediaMoal} from '@Modals/resumable-stock-modal/resumable-stock-modal';
import {DownloadPublishModalMode} from '@Components/poster-editor/components/poster-editor-nav-bar/components/nav-right-options/nav-right-options.types';
import {openUploadingImagesModal} from '@Modals/uploading-images-modal';
import {copyAndResizePoster, getWordFromUnits, resizePosterForResizeData, SizeUnits} from '@/poster-whiteboard/libraries/resize-poster.library';
import {doesSupportRemoveBackground, isIconImageItem, isItemStickerImage} from '@Libraries/image-item.library';
import {MediaTypePrompt} from '@Panels/ai-image-panel/ai-image-panel.types';
import {createKeepFiltersHiddenForTab, getAnimatedStickerSources, getSlideshowStockPanelConfig} from '@Panels/stock-panel/stock-panel.library';
import {replaceAudioItemWithGeneratedVoice} from '@Libraries/text-to-speech.library';
import {openPosterSharingModal} from '@Modals/share-modal/share-modal-library';
import {GROWL_TYPE, showMessageGrowl} from '@Components/message-growl';
import {isEditorMobileVariant} from '@Libraries/is-editor-mobile-variant';
import {isColorBackground, isVideoBackground} from '@PosterWhiteboard/page/background/background.types';
import {openMultipagePreviewThumbnailSelectionModal} from '@Modals/multipage-preview-thumbnail-selection-modal/multipage-preview-thumbnail-selection-modal.library';
import {openNewDownloadModal} from '@Modals/download-modal/download-modal.library';
import {buildColorBackgroundItemObject, buildFabricFillForBackground} from '@PosterWhiteboard/page/background/background-color.util';
import {ITEM_TYPE} from '@PosterWhiteboard/items/item/item.types';

/** The two AI panels a visual-media picker can deep-link into. */
type AiMediaPanelKey = Extract<AiPanelKey, 'ai-images' | 'ai-videos'>;

/** The only AI panel an audio picker can deep-link into. */
type AiVoicePanelKey = Extract<AiPanelKey, 'ai-voice'>;

type ReplaceStockPickerOverrides = StockMediaPopupOverrides & Pick<StockModalProps, 'onAddSelected'>;

const REMOVE_WATERMARK_MOBILE_ART_UPDATED_ON = 1786086586;
const AI_CAROUSEL_CONTENT_TYPES_VISUAL = [AiCarouselContentType.IMAGES, AiCarouselContentType.VIDEOS];
const AI_CAROUSEL_CONTENT_TYPES_IMAGES = [AiCarouselContentType.IMAGES];
const AI_CAROUSEL_CONTENT_TYPES_VIDEOS = [AiCarouselContentType.VIDEOS];
const AI_CAROUSEL_CONTENT_TYPES_AUDIO = [AiCarouselContentType.AUDIO];
// An icon can become any of these, its own medium leading.
const ICON_REPLACE_STOCK_TABS = [StockPanelTabs.ALL, StockPanelTabs.ICONS, StockPanelTabs.STICKERS, StockPanelTabs.PHOTOS, StockPanelTabs.VIDEOS];

interface BuyMoreCreditsParams {
  headingText?: string;
  modalTitle?: string;

  cb(credits?: number): void;
}

interface GettyUpsellModalParams {
  title: string;
  body: string;
  mobileBody: string;
  artSrc: string;
  isCloseIconOnDark?: boolean;
}

const hasStickerItem = (elementsData: (ItemData | TempImageData)[]): boolean => elementsData.some((el) => 'type' in el && isStickerElementType(el.type));

const containsGettyAsset = (elementsData: (ItemData | TempImageData)[]): boolean => elementsData.some((data) => getGettyAssetClassification(data) !== null);

/**
 * An optimistic upload preview whose local data URL can't be decoded (e.g. a corrupt file
 * that slipped past the mime filter) rejects while being added to the poster. The upload
 * pipeline owns the user-facing error in that case, so log rather than surface a second message.
 */
const onAddItemsFailed = (e: unknown): void => {
  console.error('Failed to add items to the poster', e);
};

/**
 * Only deliveries containing Getty-classified assets chain through this queue: the stock panel
 * streams single-item deliveries as uploads settle, and each delivery's Getty-limit check
 * (filterByGettyLimits in AddItem.addItems) must run only after the previous delivery's items
 * have committed — concurrent checks would all count the same stale state. Non-Getty adds run
 * immediately: they cannot change the Getty count, and queueing them would make unrelated adds
 * (a text box) wait behind slow media loads and share the queue's fate if an add never settles.
 * Background, slideshow, and replace adds have their own single-call entry points and are NOT
 * ordered against this queue.
 */
let pendingPosterItemAdds: Promise<void> = Promise.resolve();

export const onAddItems = (elementsData: (ItemData | TempImageData)[]): Promise<void> => {
  // Captured at call time on purpose: queued items land on the page that was current when the add was requested, even if the user switches pages while the queue drains.
  const currentPage = window.posterEditor?.whiteboard?.getCurrentPage();
  if (!currentPage) {
    return Promise.resolve();
  }

  const featureDemo = window.PMW.redux.store.getState().posterEditor.featureDemo;
  if (featureDemo === FeatureDemo.STICKERS && hasStickerItem(elementsData)) {
    trackPosterBuilderGA4Events(GA4EventName.EDITOR_TRY_STICKER, {[GA4EventParamName.USER_PREMIUM_LEVEL]: String(getUserPremiumLevel())});
    window.PMW.redux.store.dispatch(updateFeatureDemo(FeatureDemo.NONE));
  }

  if (!containsGettyAsset(elementsData)) {
    return currentPage.items.addItems.addNewItems(elementsData).catch(onAddItemsFailed);
  }

  pendingPosterItemAdds = pendingPosterItemAdds
    .then(() => {
      return currentPage.items.addItems.addNewItems(elementsData);
    })
    .catch(onAddItemsFailed);
  return pendingPosterItemAdds;
};

const onAddAudioItems = async (audioItemsData: AudioData[]): Promise<void> => {
  const currentPage = window.posterEditor?.whiteboard?.getCurrentPage();
  if (!currentPage) {
    return;
  }

  trackPosterBuilderGA4Events(GA4EventName.ADD_OWN_AUDIO);
  void currentPage.items.addItems.addAudioItems(audioItemsData, {}).catch(onAddItemsFailed);
};

export const onReplaceAudioItem = (audioItemIdToReplace: string, audioItemsData: AudioData[]): void => {
  const currentPage = window.posterEditor?.whiteboard?.getCurrentPage();
  if (!currentPage || audioItemsData.length === 0) {
    return;
  }

  void window.posterEditor?.whiteboard?.getCurrentPage().audioClips.replaceAudioItem(audioItemIdToReplace, audioItemsData[0]);
};

export const onAddMediaSlideshow = (elementsData: (ImageData | TempImageData | VideoData | PMWStillStickerData | PMWExtractedGettyStickerData)[]): void => {
  const currentPage = window.posterEditor?.whiteboard?.getCurrentPage();
  if (!currentPage) {
    return;
  }
  void currentPage.items.addItems.onAddMediaSlideshow(elementsData).catch(onAddItemsFailed);
};

export const addImageBackground = (elementsData: (ImageData | TempImageData)[]): void => {
  const currentPage = window.posterEditor?.whiteboard?.getCurrentPage();
  if (!currentPage) {
    return;
  }
  void currentPage.items.addItems.onAddImageBackground(elementsData).catch(onAddItemsFailed);
};

export const addVideoBackground = (videoData: VideoData): void => {
  const currentPage = window.posterEditor?.whiteboard?.getCurrentPage();
  if (!currentPage) {
    return;
  }
  void currentPage.items.addItems.onAddVideoBackground(videoData).catch(onAddItemsFailed);
};

export const addBackground = (elementsData: ElementData[]): void => {
  const backgroundData = elementsData[0];
  if (backgroundData.type === ElementDataType.VIDEO) {
    addVideoBackground(backgroundData);
  } else {
    addImageBackground(elementsData as (ImageData | TempImageData)[]);
  }
};

// Append-flavored variants used exclusively by the timeline track's "+"
// dropdown — they add a new bg sequentially after the existing ones instead
// of replacing the currently active one.
export const appendImageBackground = async (elementsData: (ImageData | TempImageData)[]): Promise<void> => {
  const currentPage = window.posterEditor?.whiteboard?.getCurrentPage();
  if (!currentPage) {
    return;
  }
  await currentPage.items.addItems.onAddImageBackground(elementsData, 'append');
};

export const appendVideoBackground = async (videoData: VideoData): Promise<void> => {
  const currentPage = window.posterEditor?.whiteboard?.getCurrentPage();
  if (!currentPage) {
    return;
  }
  await currentPage.items.addItems.onAddVideoBackground(videoData, 'append');
};

// Appends each selection in order; sequential awaits are required so every
// background computes its slot after the previous one has been tiled in.
export const appendBackground = async (elementsData: ElementData[]): Promise<void> => {
  showLoading('loading');
  try {
    for (const backgroundData of elementsData) {
      if (backgroundData.type === ElementDataType.VIDEO) {
        // eslint-disable-next-line no-await-in-loop -- each bg must tile in after the previous one
        await appendVideoBackground(backgroundData);
      } else {
        // eslint-disable-next-line no-await-in-loop -- each bg must tile in after the previous one
        await appendImageBackground([backgroundData as ImageData | TempImageData]);
      }
    }
  } finally {
    hideLoading('loading');
  }
};

const onOpenUserBackgroundUploadsModalSequential = (): void => {
  const page = window.posterEditor?.whiteboard?.getCurrentPage();
  if (!page) {
    return;
  }
  openUserMediaModal({
    onAddSelected: appendBackground,
    shouldLoadDataUrlImage: true,
    onAddBrandAsset: (): void => {
      void onAddBrandAssetClickedHandler();
    },
    mediaTypesToShow: [UploadsMediaType.IMAGE_BACKGROUND, UploadsMediaType.VIDEO_BACKGROUND],
    showVectors: false,
    uploadAcceptedMimetype: 'image/jpeg,image/heic,image/heif,image/png,image/webp,image/gif,video/quicktime,video/mp4,video/x-m4v,video/*',
    defaultTab: UploadsMediaType.IMAGE_BACKGROUND,
  });
};

// Timeline background-track "+" picker: every pick appends after the last background (sequential).
// Desktop opens the stock popup — directly on an AI panel when one is requested; phone keeps the
// full-screen modal (same split as every other background flow).
const openSequentialBackgroundStockPicker = (tabsToShow: StockPanelTabs[], defaultSearchTab: StockPanelTabs, initialAiPanel?: AiMediaPanelKey): void => {
  const page = window.posterEditor?.whiteboard?.getCurrentPage();
  if (!page) {
    return;
  }
  const config: StockMediaPopupOverrides = {
    onAddSelected: appendBackground,
    shouldLoadDataUrlImage: true,
    tabsToShow,
    aiCarouselContentTypes: AI_CAROUSEL_CONTENT_TYPES_VISUAL,
    defaultSearchTab,
    initialAiPanel,
    // Backgrounds append one per pick — this caps the AI panels' selection; the stock grids add per click regardless.
    maxSelectionNumber: 1,
    panelId: 'STOCK_MEDIA_VIA_BACKGROUND_SEQUENTIAL',
  };
  if (isMobile) {
    openStockMediaModal({...config, onAddSelected: appendBackground, hideOnClose: false});
    return;
  }
  openStockMediaPopup(config);
};

/** The Explore media pick for APPEND_BACKGROUND: the browse-first photos-AND-videos picker, append-flavored. */
const onOpenStockBackgroundAllMediaPickerSequential = (): void => {
  openSequentialBackgroundStockPicker([StockPanelTabs.ALL, StockPanelTabs.PHOTOS, StockPanelTabs.VIDEOS], StockPanelTabs.ALL);
};

const onOpenAiImageBackgroundModalSequential = (): void => {
  openSequentialBackgroundStockPicker([StockPanelTabs.PHOTOS, StockPanelTabs.VIDEOS], StockPanelTabs.PHOTOS, 'ai-images');
};

const onOpenAiVideoBackgroundModalSequential = (): void => {
  openSequentialBackgroundStockPicker([StockPanelTabs.VIDEOS, StockPanelTabs.PHOTOS], StockPanelTabs.VIDEOS, 'ai-videos');
};

export const onOpenUserMediaModal = (): void => {
  const currentPage = window.posterEditor?.whiteboard?.getCurrentPage();
  if (!currentPage) {
    return;
  }
  openUserMediaModal({
    onAddSelected: onAddItems,
    shouldLoadDataUrlImage: true,
    onAddBrandAsset: (): void => {
      void onAddBrandAssetClickedHandler();
    },
    defaultTab: UploadsMediaType.IMAGE,
    showEditWithAiOnGeneratedImages: true,
  });
};

export const onOpenSlideshowUserMediaModal = (): void => {
  const currentPage = window.posterEditor?.whiteboard?.getCurrentPage();
  if (!currentPage) {
    return;
  }
  openUserMediaModal({
    onAddSelected: onAddMediaSlideshow,
    shouldLoadDataUrlImage: true,
    onAddBrandAsset: (): void => {
      void onAddBrandAssetClickedHandler();
    },
    addInBulk: true,
    showVectors: false,
    uploadAcceptedMimetype: `image/jpeg,image/heic,image/heif,image/png,image/webp,image/gif,video/quicktime,video/mp4,video/x-m4v,video/*`,
    mediaTypesToShow: [UploadsMediaType.IMAGE, UploadsMediaType.VIDEO],
    defaultTab: UploadsMediaType.IMAGE,
  });
};

export const onOpenSlideshowStockMediaModal = (onAddSelected?: (elementsData: (ImageData | VideoData)[]) => void): void => {
  openStockMediaModal({
    ...getSlideshowStockPanelConfig(),
    onAddSelected: onAddSelected ?? onAddMediaSlideshow,
    selectionFooterCtaText: window.i18next.t('pmwjs_create_slideshow'),
    hideOnClose: false,
    panelId: 'STOCK_MEDIA_VIA_SLIDESHOW',
  });
};

// Desktop popup for adding a media slide to a slideshow. Slideshow is a visual flow, so it shows the AI carousel (images +
// videos) instead of the text-to-image carousel. Shared by both slideshow entry points so their config can't drift apart.
export const onOpenSlideshowAddSlidePopup = (onAddSelected: (elementsData: (ImageData | VideoData)[]) => void): void => {
  openStockMediaPopup({
    ...getSlideshowStockPanelConfig(),
    onAddSelected,
    selectionFooterCtaText: window.i18next.t('pmwjs_add_slides'),
    panelId: 'STOCK_PANEL_VIA_SLIDESHOW_ADD_SLIDE',
  });
};

/** The Uploads pick for SET_BACKGROUND: one modal listing image AND video background uploads. */
const onOpenUserBackgroundUploadsModal = (): void => {
  const currentPage = window.posterEditor?.whiteboard?.getCurrentPage();
  if (!currentPage) {
    return;
  }
  openUserMediaModal({
    onAddSelected: addBackground,
    shouldLoadDataUrlImage: true,
    onAddBrandAsset: (): void => {
      void onAddBrandAssetClickedHandler();
    },
    mediaTypesToShow: [UploadsMediaType.IMAGE_BACKGROUND, UploadsMediaType.VIDEO_BACKGROUND],
    maxSelectionNumber: 1,
    showVectors: false,
    uploadAcceptedMimetype: 'image/jpeg,image/heic,image/heif,image/png,image/webp,image/gif,video/quicktime,video/mp4,video/x-m4v,video/*',
    defaultTab: UploadsMediaType.IMAGE_BACKGROUND,
  });
};

/**
 * The Explore media pick for SET_BACKGROUND: one browse-first stock picker offering photos AND
 * videos, mirroring the replace-background picker. Desktop gets the popup, phone the modal.
 */
const openStockBackgroundAllMediaPicker = (): void => {
  const currentPage = window.posterEditor?.whiteboard?.getCurrentPage();
  if (!currentPage) {
    return;
  }
  const config: StockMediaPopupOverrides = {
    onAddSelected: addBackground,
    shouldLoadDataUrlImage: true,
    tabsToShow: [StockPanelTabs.ALL, StockPanelTabs.PHOTOS, StockPanelTabs.VIDEOS],
    defaultSearchTab: StockPanelTabs.ALL,
    aiCarouselContentTypes: AI_CAROUSEL_CONTENT_TYPES_VISUAL,
    maxSelectionNumber: 1,
    panelId: STOCK_MEDIA_VIA_BACKGROUND_PANEL_ID,
  };
  if (isMobile) {
    openStockMediaModal({
      ...config,
      onAddSelected: addBackground,
      enableMultiSelection: true,
      selectionFooterCtaText: window.i18next.t('pmwjs_add_background_2'),
      hideOnClose: false,
    });
    return;
  }
  openStockMediaPopup(config);
};

/**
 * AI background pickers that SET the page background, the counterpart to the timeline's *Sequential
 * variants which append after the last one. Desktop gets the popup, phone the full-screen modal.
 */
const openAiBackgroundPicker = (initialAiPanel: AiMediaPanelKey): void => {
  const currentPage = window.posterEditor?.whiteboard?.getCurrentPage();
  if (!currentPage) {
    return;
  }
  const isForVideo = initialAiPanel === 'ai-videos';
  const config: StockMediaPopupOverrides = {
    onAddSelected: addBackground,
    shouldLoadDataUrlImage: true,
    tabsToShow: isForVideo ? [StockPanelTabs.VIDEOS] : [StockPanelTabs.PHOTOS],
    aiCarouselContentTypes: isForVideo ? AI_CAROUSEL_CONTENT_TYPES_VIDEOS : AI_CAROUSEL_CONTENT_TYPES_IMAGES,
    defaultSearchTab: isForVideo ? StockPanelTabs.VIDEOS : StockPanelTabs.PHOTOS,
    maxSelectionNumber: 1,
    initialAiPanel,
    panelId: isForVideo ? STOCK_MEDIA_VIA_VIDEO_BACKGROUND_PANEL_ID : STOCK_MEDIA_VIA_BACKGROUND_PANEL_ID,
  };
  if (isMobile) {
    const mobileConfig: StockModalProps = {
      ...config,
      onAddSelected: addBackground,
      enableMultiSelection: true,
      selectionFooterCtaText: window.i18next.t('pmwjs_add_background_2'),
      hideOnClose: false,
    };
    openStockMediaModal(mobileConfig);
    return;
  }
  openStockMediaPopup(config);
};

const onOpenAiImageBackgroundModal = (): void => {
  openAiBackgroundPicker('ai-images');
};

const onOpenAiVideoBackgroundModal = (): void => {
  openAiBackgroundPicker('ai-videos');
};

export const onOpenStockMediaModal = (defaultSearchTab?: StockPanelTabs): void => {
  const poster = window.posterEditor?.whiteboard;
  if (poster?.mode.isRegen()) {
    openMessageModal({
      title: window.i18next.t('pmwjs_add_stock_image_disabled_title'),
      text: window.i18next.t('pmwjs_add_stock_image_disabled_message'),
    });
    return;
  }

  if (!isMobile) {
    openStockMediaPopup(defaultSearchTab !== undefined ? {defaultSearchTab} : {});
    return;
  }

  openResumableStockMediaMoal({
    bypassCompoundedView: true,
    showEditWithAiOnGeneratedImages: true,
    onAddSelected: onAddItems,
    shouldLoadDataUrlImage: true,
    aiCarouselContentTypes: AI_CAROUSEL_CONTENT_TYPES_ALL,
    hideOnClose: true,
    enableMultiSelection: true,
    selectionFooterCtaText: window.i18next.t('pmwjs_add_selected'),
    panelId: RESUMABLE_STOCK_MEDIA_PANEL_ID,
    tabId: RESUMABLE_STOCK_MEDIA_TAB_ID,
    ...(defaultSearchTab !== undefined && {defaultSearchTab}),
    stockTabToGridIdMapping: {
      [StockPanelTabs.ALL]: 'resumable-stock-grid-all',
      [StockPanelTabs.PHOTOS]: 'resumable-stock-grid-photos',
      [StockPanelTabs.TEXT_TO_IMAGE]: 'resumable-stock-grid-t2i',
      [StockPanelTabs.VIDEOS]: 'resumable-stock-grid-videos',
      [StockPanelTabs.SHAPES]: 'resumable-stock-grid-shapes',
      [StockPanelTabs.AUDIOS]: 'resumable-stock-grid-audios',
      [StockPanelTabs.STICKERS]: 'resumable-stock-grid-stickers',
      [StockPanelTabs.ICONS]: 'resumable-stock-grid-icons',
      [StockPanelTabs.FAVORITES]: 'resumable-stock-grid-favorites',
    },
  });
};

export const onOpenUserAudioModal = (): void => {
  const poster = window.posterEditor?.whiteboard;
  if (!poster) {
    return;
  }

  openUserMediaModal({
    onAddSelected: onAddAudioItems,
    defaultTab: UploadsMediaType.AUDIO,
    mediaTypesToShow: [UploadsMediaType.AUDIO],
    uploadAcceptedMimetype: 'audio/mp3,audio/*',
  });
};

export const onOpenUserAudioUploadModalForReplace = (audioItemIdToReplace: string): void => {
  const poster = window.posterEditor?.whiteboard;
  if (!poster) {
    return;
  }

  openUserMediaModal({
    onAddSelected: (items: AudioData[]) => {
      onReplaceAudioItem(audioItemIdToReplace, items);
    },
    onAddBrandAsset: (): void => {
      void onAddBrandAssetClickedHandler();
    },
    maxSelectionNumber: 1,
    defaultTab: UploadsMediaType.AUDIO,
    mediaTypesToShow: [UploadsMediaType.AUDIO],
    uploadAcceptedMimetype: 'audio/mp3,audio/*',
  });
};

/**
 * Every replace picker opens the same two ways: the desktop stock popup, or — on phones — the
 * full-screen stock modal with a selection footer whose CTA names the medium being replaced. The
 * write-back is required rather than optional because the phone modal cannot open without one.
 */
const openStockPickerForReplace = (overrides: ReplaceStockPickerOverrides, mobileSelectionFooterCtaText: string): void => {
  if (isMobile) {
    openStockMediaModal({
      ...overrides,
      enableMultiSelection: true,
      selectionFooterCtaText: mobileSelectionFooterCtaText,
      hideOnClose: false,
    });
    return;
  }
  openStockMediaPopup(overrides);
};

const openStockAudioPickerForReplace = (audioItemIdToReplace: string, initialAiPanel: AiVoicePanelKey | undefined): void => {
  const poster = window.posterEditor?.whiteboard;
  if (!poster) {
    return;
  }

  if (poster.mode.isRegen()) {
    openMessageModal({
      title: window.i18next.t('pmwjs_add_stock_audio_disabled_title'),
      text: window.i18next.t('pmwjs_add_stock_audio_disabled_message'),
    });
    return;
  }

  openStockPickerForReplace(
    {
      onAddSelected: onReplaceAudioItem.bind(null, audioItemIdToReplace),
      tabsToShow: [StockPanelTabs.AUDIOS],
      aiCarouselContentTypes: AI_CAROUSEL_CONTENT_TYPES_AUDIO,
      defaultSearchTab: StockPanelTabs.AUDIOS,
      maxSelectionNumber: 1,
      panelId: 'STOCK_MEDIA_VIA_AUDIO_REPLACE',
      // An AI voice picked mid-replace swaps the selected clip rather than adding a new one.
      onAddVoiceItem: async (idGeneratedVoice: number): Promise<void> => {
        await replaceAudioItemWithGeneratedVoice(audioItemIdToReplace, idGeneratedVoice);
      },
      initialAiPanel,
    },
    window.i18next.t('pmwjs_replace_audio_2')
  );
};

export const onOpenStockAudioModalForReplace = (audioItemIdToReplace: string): void => {
  openStockAudioPickerForReplace(audioItemIdToReplace, undefined);
};

export const onOpenAiVoicePanelForReplace = (audioItemIdToReplace: string): void => {
  openStockAudioPickerForReplace(audioItemIdToReplace, 'ai-voice');
};

/** Shapes replace straight from the Shapes grid — no source dropdown, mirroring the audio stock flow. */
export const onOpenStockShapeModalForReplace = (): void => {
  if (!window.posterEditor?.whiteboard) {
    return;
  }

  openStockPickerForReplace(
    {
      onAddSelected: (items: ElementData[]): void => {
        if (items[0]) {
          onReplaceShape(items[0]);
        }
      },
      tabsToShow: [StockPanelTabs.SHAPES],
      defaultSearchTab: StockPanelTabs.SHAPES,
      maxSelectionNumber: 1,
      panelId: 'STOCK_MEDIA_VIA_SHAPE_REPLACE',
    },
    window.i18next.t('pmwjs_replace_shape')
  );
};

/** The mobile bottom bars all track the same GA4 source before opening the shape picker. */
export const openShapeReplaceFromBottomBar = (): void => {
  trackPosterBuilderGA4Events(GA4EventName.REPLACE_ELEMENT, {[GA4EventParamName.SOURCE]: GA4EventSources.MOBILE_BOTTOM_BAR});
  onOpenStockShapeModalForReplace();
};

/** Audio has no image/video split, so its flat menu offers Uploads, Explore media and the AI voice generator. */
export const onOpenReplaceAudio = (selection: ReplaceSourceSelection, audioItemIdToReplace: string): void => {
  switch (selection.kind) {
    case MediaSourceKind.STOCK:
      onOpenStockAudioModalForReplace(audioItemIdToReplace);
      return;
    case MediaSourceKind.UPLOADS:
      onOpenUserAudioUploadModalForReplace(audioItemIdToReplace);
      return;
    case MediaSourceKind.AI:
      onOpenAiVoicePanelForReplace(audioItemIdToReplace);
      return;
    default:
      assertNever(selection);
  }
};

export const openTrimAudioModalForSelectedAudioItem = (): void => {
  const currentAudioItem = window.posterEditor?.whiteboard?.getCurrentPage().audioClips.getSelectedAudioItem();
  if (!window.posterEditor?.whiteboard || !currentAudioItem) {
    return;
  }

  openTrimAudioModal({
    duration: currentAudioItem.audioPlayer.originalDuration,
    start: currentAudioItem.audioPlayer.getTrimmedStartTime(),
    end: currentAudioItem.audioPlayer.getTrimmedEndTime(),
    source: getAudioUrl(currentAudioItem.hashedFilename, currentAudioItem.source),
    audioTitle: currentAudioItem.name,
    onTrim: (trimData) => {
      trackPosterBuilderGA4Events(GA4EventName.TRIM_AUDIO_MODAL, {
        [GA4EventParamName.TYPE]: isEditorMobileVariant() ? 'mobile' : 'web',
      });
      void window.posterEditor?.whiteboard?.getCurrentPage().audioClips.trimAudioItem(currentAudioItem.uid, trimData.startTime, trimData.endTime);
    },
    maxDuration: currentAudioItem.audioPlayer.originalDuration,
  });
};

const getGettyUpsellBulletPoints = (): string[] => {
  return [
    window.i18next.t('pmwjs_getty_upsell_bullet_unlimited_stock'),
    window.i18next.t('pmwjs_getty_upsell_bullet_watermark_free'),
    window.i18next.t('pmwjs_getty_upsell_bullet_ai_suite'),
  ];
};

const getGettyUpsellTrialAction = (isTrialEligible: boolean): SplitUpsellAction | undefined => {
  if (!isTrialEligible) {
    return undefined;
  }

  return {
    text: window.i18next.t('pmwjs_try_it_free'),
    onClick: (): void => {
      openPremiumPricingModal(true, GETTY_STOCK_CONTENT_UPSELL);
    },
  };
};

const openGettyUpsellModal = async (params: GettyUpsellModalParams): Promise<void> => {
  const isTrialEligible = await isCurrentUserEligibleForFreeTrial();

  openSplitUpsellModal({
    title: params.title,
    body: params.body,
    mobileBody: params.mobileBody,
    bulletPoints: getGettyUpsellBulletPoints(),
    artSrc: params.artSrc,
    isCloseIconOnDark: params.isCloseIconOnDark,
    // Naming the upsell lets the pricing card hoist its own crown-highlighted "watermark-free downloads" row
    // and drop the plain downloads row it duplicates, instead of the card carrying both unconditionally.
    primaryAction: {
      text: window.i18next.t('pmwjs_upgrade'),
      onClick: (): void => {
        openPremiumPricingModal(false, GETTY_STOCK_CONTENT_UPSELL);
      },
    },
    secondaryAction: getGettyUpsellTrialAction(isTrialEligible),
  });
};

/**
 * Copy, art and analytics for the per-type "you've hit the Getty limit" dialog. One row per asset type so the
 * three dialogs cannot drift apart, and so a new type is a row rather than a fourth near-identical function.
 */
const GETTY_LIMIT_UPSELL_BY_TYPE = {
  [GettyAssetType.IMAGE]: {
    ga4Event: GA4EventName.GETTY_IMAGE_LIMIT_REACHED,
    titleKey: 'pmwjs_getty_photos_limit_title',
    bodyKey: 'pmwjs_getty_photos_limit_body',
    mobileBodyKey: 'pmwjs_getty_photos_limit_body_mobile',
    artFile: 'getty-limit-photos-art.jpg',
  },
  [GettyAssetType.VIDEO]: {
    ga4Event: GA4EventName.GETTY_VIDEO_LIMIT_REACHED,
    titleKey: 'pmwjs_getty_videos_limit_title',
    bodyKey: 'pmwjs_getty_videos_limit_body',
    mobileBodyKey: 'pmwjs_getty_videos_limit_body_mobile',
    artFile: 'getty-limit-videos-art.jpg',
  },
  [GettyAssetType.EXTRACTED_STICKER]: {
    ga4Event: GA4EventName.EXTRACTED_GETTY_STICKER_LIMIT_REACHED,
    titleKey: 'pmwjs_getty_stickers_limit_title',
    bodyKey: 'pmwjs_getty_stickers_limit_body',
    mobileBodyKey: 'pmwjs_getty_stickers_limit_body_mobile',
    artFile: 'getty-limit-stickers-art.jpg',
  },
} as const;

const openGettyLimitReachedUpsellModal = (gettyType: GettyAssetType): void => {
  const upsell = GETTY_LIMIT_UPSELL_BY_TYPE[gettyType];
  trackPosterBuilderGA4Events(upsell.ga4Event);
  void openGettyUpsellModal({
    title: window.i18next.t(upsell.titleKey),
    body: window.i18next.t(upsell.bodyKey, {limit: POSTER_GETTY_LIMIT[gettyType]}),
    mobileBody: window.i18next.t(upsell.mobileBodyKey, {limit: POSTER_GETTY_LIMIT[gettyType]}),
    artSrc: getAssetUrl(upsell.artFile),
  });
};

export const openGettyWatermarkUpsellModal = (): void => {
  void openGettyUpsellModal({
    title: window.i18next.t('pmwjs_getty_watermark_upsell_title'),
    body: window.i18next.t('pmwjs_getty_watermark_upsell_body'),
    mobileBody: window.i18next.t('pmwjs_getty_watermark_upsell_body_mobile'),
    artSrc: getAssetUrl(isMobile ? `getty-remove-watermark-upsell-art-mobile.jpg?ts=${REMOVE_WATERMARK_MOBILE_ART_UPDATED_ON}` : 'getty-remove-watermark-upsell-art.jpg'),
    isCloseIconOnDark: true,
  });
};

/** Several types hit their limit at once, so no single limit number applies and Figma has no dedicated art. */
const openGettyAssetsLimitReachedUpsellModal = (): void => {
  void openGettyUpsellModal({
    title: window.i18next.t('pmwjs_getty_assets_limit_title'),
    body: window.i18next.t('pmwjs_getty_assets_limit_body'),
    mobileBody: window.i18next.t('pmwjs_getty_assets_limit_body_mobile'),
    artSrc: getAssetUrl(GETTY_LIMIT_UPSELL_BY_TYPE[GettyAssetType.IMAGE].artFile),
  });
};

export const notifyGettyLimitReached = (droppedTypes: Set<GettyAssetType>): void => {
  if (droppedTypes.size === 0) {
    return;
  }
  closeStockMediaPopup();
  if (droppedTypes.size > 1) {
    droppedTypes.forEach((droppedType) => {
      trackPosterBuilderGA4Events(GETTY_LIMIT_UPSELL_BY_TYPE[droppedType].ga4Event);
    });
    openGettyAssetsLimitReachedUpsellModal();
    return;
  }
  if (droppedTypes.has(GettyAssetType.IMAGE)) {
    openGettyLimitReachedUpsellModal(GettyAssetType.IMAGE);
  } else if (droppedTypes.has(GettyAssetType.VIDEO)) {
    openGettyLimitReachedUpsellModal(GettyAssetType.VIDEO);
  } else {
    openGettyLimitReachedUpsellModal(GettyAssetType.EXTRACTED_STICKER);
  }
};

export const onOpenStockAudioModal = (initialAiPanel?: 'ai-voice'): void => {
  const poster = window.posterEditor?.whiteboard;
  if (!poster) {
    return;
  }

  if (poster.mode.isRegen()) {
    openMessageModal({
      title: window.i18next.t('pmwjs_add_stock_audio_disabled_title'),
      text: window.i18next.t('pmwjs_add_stock_audio_disabled_message'),
    });
    return;
  }

  if (isMobile) {
    openStockMediaModal({
      onAddSelected: onAddAudioItems,
      tabsToShow: [StockPanelTabs.AUDIOS],
      aiCarouselContentTypes: AI_CAROUSEL_CONTENT_TYPES_AUDIO,
      defaultSearchTab: StockPanelTabs.AUDIOS,
      enableMultiSelection: true,
      selectionFooterCtaText: window.i18next.t('pmwjs_add_selected'),
      hideOnClose: false,
      initialAiPanel,
      panelId: 'STOCK_MEDIA_VIA_AUDIO',
    });
    return;
  }

  openStockMediaPopup({
    onAddSelected: onAddAudioItems,
    tabsToShow: [StockPanelTabs.AUDIOS],
    aiCarouselContentTypes: AI_CAROUSEL_CONTENT_TYPES_AUDIO,
    defaultSearchTab: StockPanelTabs.AUDIOS,
    initialAiPanel,
    panelId: 'STOCK_MEDIA_VIA_AUDIO',
  });
};

export const onOpenResizeModal = (): void => {
  const poster = window.posterEditor?.whiteboard;
  if (!poster) {
    return;
  }

  const getPosterInformationText = (): ResizeModalPosterInformation | undefined => {
    if (!window.PMW.redux.store.getState().posterEditor.isMobileVariant) {
      return undefined;
    }

    const showCustomSize = window.posterEditor?.whiteboard?.type.isCustomSize() && window.posterEditor?.whiteboard?.type.idUserPosterType === 0;
    let subText = '';
    if (showCustomSize) {
      if (poster.width && poster.units && poster.height) {
        subText = `${poster.width}${poster.units} x ${poster.height}${poster.units}`;
      }
    } else if (poster.type.description) {
      subText = poster.type.description;
    }

    return {
      posterType: window.PMW.redux.store.getState().posterEditor.posterObject?.type.displayName,
      posterDimensionText: subText,
    };
  };

  openResizeModal({
    allowSaveCustomSize: isUserLoggedIn(),
    allowMultiSelect: !isMobile && !window.PMW.isEmbedded(),
    unsavedCustomDimension: {
      width: poster.userWidth,
      height: poster.userHeight,
      units: getWordFromUnits(poster.units),
    },
    onResizeCallback: resizePosterForResizeData,
    onCopyAndResize: (data: CopyAndResizeData): void => {
      void copyAndResizePoster(data);
    },
    currentUnit: SizeUnits.PX,
    currentHeight: poster.height,
    currentWidth: poster.width,
    posterInformation: getPosterInformationText(),
  });
};

export const onOpenSettingsModal = (): void => {
  openSettingsModal({
    onLangChange: async (): Promise<void> => {
      if (window.posterEditor?.whiteboard?.savePoster.hasUnsavedChanges()) {
        await window.posterEditor?.whiteboard?.savePoster.save();
      }
    },
    onOpenAccessibilityMenu: (): void => {
      window.PMW.initAccessibilityMenu();
    },
  });
};

export const onOpenLanguageModal = (): void => {
  openPosterEditorLanguageModal({
    panelId: 'poster-editor-language-panel',
    onLangChange: async (): Promise<void> => {
      if (window.posterEditor?.whiteboard?.savePoster.hasUnsavedChanges()) {
        await window.posterEditor?.whiteboard?.savePoster.save();
      }
    },
  });
};

const addTableToPoster = (tableData: UserTableProps): void => {
  const currentPage = window.posterEditor?.whiteboard?.getCurrentPage();
  if (!currentPage) {
    return;
  }
  void currentPage.items.addItems.addTableItem(
    {
      type: ElementDataType.TABLE,
      ...tableData,
    } as TableData,
    {},
    true
  );
};

export const onOpenTableModal = (): void => {
  const data = getDefaultTableData();
  openTableModal({
    isNew: true,
    initialTableData: data,
    initialRows: DEFAULT_ROWS,
    initialColumns: DEFAULT_COLUMNS,
    highlightedRows: [],
    onAddTable: addTableToPoster,
  });
};

export const openEditTableContentModal = (activeItem: TableItem): void => {
  if (activeItem.isSchedule()) {
    openEditScheduleModal(activeItem);
  } else {
    openEditTableModal(activeItem);
  }
};

export const openEditTableModal = (tableItem: TableItem): void => {
  const data = getTableData(tableItem.layoutDataMap, tableItem.rows);

  openTableModal({
    isNew: !tableItem,
    initialRows: tableItem.rows,
    initialColumns: tableItem.columns,
    onAddTable: tableItem.updateFromTableData.bind(tableItem),
    highlightedRows: data.highlightedRows,
    initialTableData: data.tableData,
  });
};

export const openEditScheduleModal = (tableItem: TableItem): void => {
  const data = getScheduleData(tableItem);

  openScheduleModal({
    isNew: !tableItem,
    unusedData: data.unusedData,
    timeFormat: data.timeFormat,
    dateFormat: data.dateFormat,
    initialColumns: data.columns,
    columnsData: data.columnData,
    initialTableData: data.tableData,
    highlightedRows: data.highlightedRows,
    initialRows: tableItem.rows,
    layout: tableItem.layoutStyle as unknown as LayoutData,
    onAddSchedule: tableItem.updateFromScheduleData.bind(tableItem),
  });
};

export const openEditMenuModal = (menuItem: MenuItem): void => {
  openUserMenuModal({
    layout: menuItem.layoutStyle,
    selectedIds: menuItem.itemIds.map((id) => {
      return id;
    }),
    selectedItems: getSelectedMenuItems(menuItem),
    onAddMenuItem: menuItem.updateFromMenuData.bind(menuItem),
  });
};

export const openCollaboratorsModal = (): void => {
  void window.posterEditor?.whiteboard?.savePoster.save().then(() => {
    const poster = window.posterEditor?.whiteboard;
    openPosterSharingModal(poster?.hashedID ?? '', CollabOpenedSource.EDITOR);
  });
};

export const onOpenDownloadModal = (mode = DownloadPublishModalMode.DOWNLOAD, option = ''): void => {
  const poster = window.posterEditor?.whiteboard;
  if (poster) {
    const doesPosterHaveUploadingImages = poster.areAnyImagesUploading();
    const imageSrc = poster.getImageSrcOfUploadingImage();

    if (doesPosterHaveUploadingImages && imageSrc) {
      openUploadingImagesModal({
        title: window.i18next.t('pmwjs_uploading_images'),
        text: window.i18next.t('pmwjs_uploading_images_download_modal_description'),
        imgSrc: imageSrc,
      });
    } else {
      openDownloadModal(mode, option);
    }
  } else {
    openDownloadModal(mode, option);
  }
};

export const openNewDownloadDialog = (): void => {
  const posterObject = window.posterEditor?.whiteboard?.toObject();
  if (!posterObject) {
    return;
  }

  if (isEditorMobileVariant()) {
    openNewDownloadModal({
      id: 'mobile-download-panel',
      posterObject: posterObject,
      isOpenedInEditor: true,
      isOpenedInModal: true,
      isOpenedInPrintShop: false,
    });
    return;
  }

  window.PMW.redux.store.dispatch(updateWebDownloadPanelOpenState(true));
};

export const openDownloadModal = (mode = DownloadPublishModalMode.DOWNLOAD, option = '', hashedId?: string): void => {
  if (window.posterEditor?.whiteboard?.drawing.isDrawModeOn) {
    window.posterEditor?.whiteboard?.drawing.updateFromObject({
      isDrawModeOn: false,
    });
  }

  window.posterEditor?.whiteboard?.deleteItemsNotVisibleOnPoster(false);
  window.PMW.openDownloadDialog({
    isPosterMaker: window.PMW.isPosterMaker() ? 1 : 0,
    preselectPaidProduct: window.PMW.isEmbedded() && isUserPremium(),
    panelToSelect: mode,
    option,
    idPosterHash: window.posterEditor?.whiteboard?.id !== undefined && Number(window.posterEditor?.whiteboard?.id) > 0 ? window.posterEditor?.whiteboard?.hashedID : hashedId || '',
    isPremium: window.posterEditor?.whiteboard?.getCurrentPage().isPremium() ? 1 : 0,
    posterType: window.posterEditor?.whiteboard?.type.name,
    idGalleryTemplate: window.posterEditor?.whiteboard?.getGalleryTemplateId(),
    idTemplate: window.posterEditor?.whiteboard?.getTemplateId(),
    uc: window.posterEditor?.whiteboard?.savePoster.hasUnsavedChanges() ? 1 : 0,
    isVideo: window.posterEditor?.whiteboard?.isVideo() ? 1 : 0,
    hasVideoItem: window.posterEditor?.whiteboard?.getCurrentPage().items.hasVideoItem() ? 1 : 0,
    isExpensiveVideo: window.posterEditor?.whiteboard?.getCurrentPage().isExpensiveVideo() ? 1 : 0,
    isTransparent: window.posterEditor?.whiteboard?.getCurrentPage().isTransparent() ? 1 : 0,
    hasClickableLink: window.posterEditor?.whiteboard?.getCurrentPage().items.hasClickableItem() ? 1 : 0,
    pw: window.posterEditor?.whiteboard?.width,
    ph: window.posterEditor?.whiteboard?.height,
    ptw: window.posterEditor?.whiteboard?.userWidth,
    pth: window.posterEditor?.whiteboard?.userHeight,
    ptu: window.posterEditor?.whiteboard?.units,
  });
};

export const onOpenUploadsMediaSlideshowModal = (onAddSelected: (items: ItemData[]) => void): void => {
  openUserMediaModal({
    onAddSelected,
    shouldLoadDataUrlImage: true,
    onAddBrandAsset: (): void => {
      void onAddBrandAssetClickedHandler();
    },
    showVectors: false,
    uploadAcceptedMimetype: 'image/jpeg,image/heic,image/heif,image/png,image/webp,image/gif,video/quicktime,video/mp4,video/x-m4v,video/*',
    defaultTab: UploadsMediaType.IMAGE,
    mediaTypesToShow: [UploadsMediaType.IMAGE, UploadsMediaType.VIDEO],
  });
};

export const onOpenFancyTextModal = (dropPosition?: CanvasDropPosition): void => {
  openFancytextModal({
    onAddSelected: (data: ItemData): void => {
      void onAddItems([placeItemAtDropPosition(data, dropPosition)]);
    },
  });
};

export const onOpenScheduleModal = (): void => {
  const data = getDefaultScheduleData();

  openScheduleModal({
    isNew: true,
    unusedData: data.unusedData,
    timeFormat: data.timeFormat,
    dateFormat: data.dateFormat,
    initialColumns: data.columns,
    columnsData: data.columnData,
    initialTableData: data.tableData,
    highlightedRows: data.highlightedRows,
    initialRows: DEFAULT_ROWS,
    layout: LayoutData.SLANTED_SPORTS_LAYOUT,
    onAddSchedule: addScheduleToPoster,
  });
};

export const onOpenMenuModal = (): void => {
  openUserMenuModal({
    layout: LayoutTypes.MENU_LAYOUT_1,
    selectedIds: [],
    selectedItems: [],
    onAddMenuItem: addMenuToPoster,
  });
};

const trimVideoCallback = async (item: VideoItem | VideoSlideItem, trimData: TrimData): Promise<void> => {
  // A new trim window invalidates the loop phase (the offset may exceed it) — the clip restarts from its trim start.
  if (item.isVideoSlide()) {
    const newSlideDuration = (trimData.endTime - trimData.startTime) / (item.speed ?? 1);
    await item.slideshow.updateSlideFromObject(
      item.uid,
      {
        ...trimData,
        loopStartOffset: 0,
        slideDuration: newSlideDuration,
      },
      {}
    );
    await item.onItemTrimmed();
    return;
  }

  await item.updateFromObject(
    {
      ...trimData,
      loopStartOffset: 0,
    },
    {}
  );
  await item.onItemTrimmed();
};

export const onOpenTrimVideoModal = (activeItem: VideoItem | VideoSlideItem, forceTrim = false, callback = (): void => {}): void => {
  openTrimVideoModal({
    isMuted: activeItem.isMuted(),
    scaledHeight: activeItem.fabricObject.getScaledHeight(),
    scaledWidth: activeItem.fabricObject.getScaledWidth(),
    duration: activeItem.duration,
    start: activeItem.startTime,
    end: activeItem.endTime,
    source: repoVideoURLForModel(activeItem),
    maxDuration: activeItem.duration,
    panelId: 'trim-video-modal',
    onTrim: async (trimData: TrimData): Promise<void> => {
      trackPosterBuilderGA4Events(GA4EventName.TRIM_VIDEO_MODAL, {
        [GA4EventParamName.TYPE]: isEditorMobileVariant() ? 'mobile' : 'web',
      });
      await trimVideoCallback(activeItem, trimData);
      callback();
    },
    forceTrim,
  });
};

export const onClickRemoveVideoBG = async (item: VideoItem | VideoSlideItem, remainingTeamCredits: number | null): Promise<void> => {
  void window.posterEditor?.whiteboard?.pause();

  if (item.removeBackground.isBackgroundRemoved && !item.removeBackground.isBackgroundBeingRemoved) {
    showMessageGrowl({
      text: window.i18next.t('pmwjs_item_background_is_removed'),
      type: GROWL_TYPE.NEUTRAL,
    });
    await item.disableRemoveBackgroundFlag();
    return;
  }

  if (remainingTeamCredits === null) {
    return;
  }

  const creditsToCharge = await item.removeBackground.getCreditsToChargeForBackgroundRemovalForUser();
  const isInsufficientCredits = remainingTeamCredits < creditsToCharge;
  if (!isPremiumUser() && isInsufficientCredits) {
    void window.PMW.showPremiumOnlyFeatureDialog(window.PMW.PREMIUM_ONLY_FEATURE_NAME_VIDEO_BG_REMOVALS, {entryPoint: UpsellDialogEntryPoint.EDITOR_VIDEO_BG_REMOVAL_REQUEST});
    return;
  }

  if (creditsToCharge > 0 && !isInsufficientCredits) {
    void onOpenRemoveVideoBackgroundModal(item, creditsToCharge, remainingTeamCredits);
  } else if (isInsufficientCredits) {
    triggerBuyMoreCredits({
      headingText: window.i18next.t('pmwjs_credits_pack_on_background_removal', {
        creditsRemaining: remainingTeamCredits,
        creditsCost: creditsToCharge,
      }),
      cb: onCreditsPurchaseSuccess.bind(this, item),
    });
  } else {
    void onConfirmRemoveBG(item);
  }
};

export const onCreditsPurchaseSuccess = (item: VideoItem | VideoSlideItem, updatedCredits: number): void => {
  void refreshTeamCreditsInStore();
  void onClickRemoveVideoBG(item, updatedCredits);
};

export const onOpenRemoveVideoBackgroundModal = async (
  activeItem: VideoItem | VideoSlideItem,
  creditsToCharge: number,
  remainingBackgroundRemovalCredits: number
): Promise<void> => {
  openConfirmRemoveVideoBackgroundModal({
    onConfirm: onConfirmRemoveBG.bind(this, activeItem),
    remainingCredits: remainingBackgroundRemovalCredits,
    creditsToCharge,
    videoHashedFilename: activeItem.hashedFilename,
    videoFileExtension: activeItem.fileExtension,
    videoDuration: activeItem.getDuration(),
  });
};

export const onConfirmRemoveBG = async (item: VideoItem | VideoSlideItem): Promise<void> => {
  if (item.isVideoSlide()) {
    removeVideoSlideBackgroundFromId(item.slideshow.uid, item.uid, UpsellDialogEntryPoint.EDITOR_VIDEO_BG_REMOVAL_REQUEST);
  } else {
    removeVideoBackgroundFromId(item.uid, UpsellDialogEntryPoint.EDITOR_VIDEO_BG_REMOVAL_REQUEST);
  }
};

const openBackgroundReplaceSource = (selection: ReplaceSourceSelection): void => {
  const isForVideo = isVideoBackground(window.posterEditor?.whiteboard?.getCurrentPage().items.getBackgroundBeingEdited());

  const getReplaceBackgroundPopupOverrides = (): ReplaceStockPickerOverrides => {
    return {
      onAddSelected: addBackground,
      shouldLoadDataUrlImage: true,
      maxSelectionNumber: 1,
      // ALL leads so Explore media opens on the carousel browse view; the background's own media
      // type orders the rest, and both media tabs stay so an image background can still become a video.
      tabsToShow: isForVideo ? [StockPanelTabs.ALL, StockPanelTabs.VIDEOS, StockPanelTabs.PHOTOS] : [StockPanelTabs.ALL, StockPanelTabs.PHOTOS, StockPanelTabs.VIDEOS],
      defaultSearchTab: StockPanelTabs.ALL,
      aiCarouselContentTypes: AI_CAROUSEL_CONTENT_TYPES_VISUAL,
      panelId: 'STOCK_MEDIA_VIA_REPLACE_BACKGROUND',
      shouldReplaceOnGenerate: true,
    };
  };

  const openStockBackgroundReplaceModal = (): void => {
    openStockPickerForReplace(getReplaceBackgroundPopupOverrides(), window.i18next.t('pmwjs_replace_background_2'));
  };

  const openMyBackgroundsModal = (): void => {
    openUserMediaModal({
      onAddSelected: addBackground,
      shouldLoadDataUrlImage: true,
      onAddBrandAsset: (): void => {
        void onAddBrandAssetClickedHandler();
      },
      mediaTypesToShow: [UploadsMediaType.IMAGE_BACKGROUND, UploadsMediaType.VIDEO_BACKGROUND],
      maxSelectionNumber: 1,
      showVectors: false,
      uploadAcceptedMimetype: 'image/jpeg,image/heic,image/heif,image/png,image/webp,image/gif,video/quicktime,video/mp4,video/x-m4v,video/*',
      defaultTab: isForVideo ? UploadsMediaType.VIDEO_BACKGROUND : UploadsMediaType.IMAGE_BACKGROUND,
    });
  };

  const openAiBackgroundReplace = (requestedAiPanel: ReplaceAiPanelKey): void => {
    // Backgrounds have no sticker or voice branch, so any other panel request degrades to the image generator.
    const initialAiPanel: AiMediaPanelKey = requestedAiPanel === 'ai-videos' ? 'ai-videos' : 'ai-images';
    openStockPickerForReplace({...getReplaceBackgroundPopupOverrides(), initialAiPanel}, window.i18next.t('pmwjs_replace_background_2'));
  };

  switch (selection.kind) {
    case MediaSourceKind.STOCK:
      openStockBackgroundReplaceModal();
      return;
    case MediaSourceKind.UPLOADS:
      openMyBackgroundsModal();
      return;
    case MediaSourceKind.AI:
      openAiBackgroundReplace(selection.aiPanel);
      return;
    default:
      assertNever(selection);
  }
};

const openItemReplaceSource = (selection: ReplaceSourceSelection, item: ReplaceableMediaItem, onReplace: (itemData: ItemData) => void): void => {
  const replaceFromSelection = (items: ElementData[]): void => {
    if (items[0]) {
      onReplace(items[0]);
    }
  };

  const isIconReplace = isIconImageItem(item);
  const isStickerReplace = isItemStickerImage(item);
  const isForVideo = item.isVideo() || item.isVideoSlide();

  const getReplacePopupOverrides = (): ReplaceStockPickerOverrides => {
    const base: ReplaceStockPickerOverrides = {
      onAddSelected: replaceFromSelection,
      shouldLoadDataUrlImage: true,
      maxSelectionNumber: 1,
      aiCarouselContentTypes: AI_CAROUSEL_CONTENT_TYPES_VISUAL,
      // ALL leads so Explore media opens on the carousel browse view; the rest is the tab and carousel row order.
      defaultSearchTab: StockPanelTabs.ALL,
      panelId: 'STOCK_PANEL_VIA_REPLACE_MEDIA',
      shouldReplaceOnGenerate: true,
    };
    if (isIconReplace) {
      return {
        ...base,
        tabsToShow: ICON_REPLACE_STOCK_TABS,
        // An icon replaces into a still image item, so animated variants stay out of the carousel, grid, and
        // recents — and the stickers tab hides its filter row, whose Animated/Still split is meaningless here.
        blacklistedSources: getAnimatedStickerSources(),
        keepFiltersHiddenForTab: createKeepFiltersHiddenForTab([StockPanelTabs.STICKERS]),
      };
    }
    if (isStickerReplace) {
      return {
        ...base,
        tabsToShow: [StockPanelTabs.ALL, StockPanelTabs.STICKERS, StockPanelTabs.PHOTOS, StockPanelTabs.VIDEOS, StockPanelTabs.ICONS],
        defaultAiImageMediaType: MediaTypePrompt.STICKER,
        // A sticker gets replaced with a still sticker, so animated variants stay out of the carousel, grid, and recents.
        blacklistedSources: getAnimatedStickerSources(),
        allowedFiltersForTab: {[StockPanelTabs.STICKERS]: [StockButtonFilters.PRICING]},
      };
    }
    if (item.isSlideshowSlide()) {
      // A slideshow slide can only swap for another photo or video; its own medium leads.
      return {
        ...base,
        tabsToShow: isForVideo ? [StockPanelTabs.ALL, StockPanelTabs.VIDEOS, StockPanelTabs.PHOTOS] : [StockPanelTabs.ALL, StockPanelTabs.PHOTOS, StockPanelTabs.VIDEOS],
      };
    }
    return {
      ...base,
      // A photo or video can also become a sticker or icon, its own medium leading.
      tabsToShow: isForVideo
        ? [StockPanelTabs.ALL, StockPanelTabs.VIDEOS, StockPanelTabs.PHOTOS, StockPanelTabs.STICKERS, StockPanelTabs.ICONS]
        : [StockPanelTabs.ALL, StockPanelTabs.PHOTOS, StockPanelTabs.VIDEOS, StockPanelTabs.STICKERS, StockPanelTabs.ICONS],
      // It replaces into a still image item, so animated stickers stay out of the carousel, grid, and
      // recents — and the stickers tab keeps only its pricing filter, since the Animated/Still split is meaningless here.
      blacklistedSources: getAnimatedStickerSources(),
      allowedFiltersForTab: {[StockPanelTabs.STICKERS]: [StockButtonFilters.PRICING]},
    };
  };

  // Names the media being replaced, which is what the flat menu is keyed to. An icon can become any
  // of several media types, so it keeps the unqualified wording.
  const getReplaceCtaText = (): string => {
    if (isIconReplace) {
      return window.i18next.t('pmwjs_replace');
    }
    if (isStickerReplace) {
      return window.i18next.t('pmwjs_replace_sticker');
    }
    if (isForVideo) {
      return window.i18next.t('pmwjs_replace_video_2');
    }
    return window.i18next.t('pmwjs_replace_photo');
  };

  const onOpenStockModal = (): void => {
    openStockPickerForReplace(getReplacePopupOverrides(), getReplaceCtaText());
  };

  const openUploadsMediaModal = (): void => {
    openUserMediaModal({
      shouldLoadDataUrlImage: true,
      onAddSelected: replaceFromSelection,
      maxSelectionNumber: 1,
      onAddBrandAsset: (): void => {
        void onAddBrandAssetClickedHandler();
      },
      showVectors: !item.isSlideshowSlide(),
      uploadAcceptedMimetype: `${item.isSlideshowSlide() ? 'image/jpeg,image/heic,image/heif,image/png,image/webp,image/gif' : 'image/*,image/heic,image/heif'},video/quicktime,video/mp4,video/x-m4v,video/*`,
      defaultTab: isForVideo ? UploadsMediaType.VIDEO : UploadsMediaType.IMAGE,
      mediaTypesToShow: [UploadsMediaType.IMAGE, UploadsMediaType.VIDEO],
    });
  };

  const openAiPanelForReplace = (initialAiPanel: ReplaceAiPanelKey): void => {
    openStockPickerForReplace({...getReplacePopupOverrides(), initialAiPanel}, getReplaceCtaText());
  };

  switch (selection.kind) {
    case MediaSourceKind.STOCK:
      onOpenStockModal();
      return;
    case MediaSourceKind.UPLOADS:
      openUploadsMediaModal();
      return;
    case MediaSourceKind.AI:
      openAiPanelForReplace(selection.aiPanel);
      return;
    default:
      assertNever(selection);
  }
};

/**
 * One intent's flat background source openers. Uploads and Explore media span media types (their
 * pickers list image AND video backgrounds), so only the AI generators split by medium.
 */
interface BackgroundSourceOpeners {
  uploads: () => void;
  stock: () => void;
  ai: Record<MediaSourceGroup, () => void>;
}

/** Timeline "+": every pick tiles a NEW background in after the last one. */
const APPEND_BACKGROUND_OPENERS: BackgroundSourceOpeners = {
  uploads: onOpenUserBackgroundUploadsModalSequential,
  stock: onOpenStockBackgroundAllMediaPickerSequential,
  ai: {
    [MediaSourceGroup.IMAGE]: onOpenAiImageBackgroundModalSequential,
    [MediaSourceGroup.VIDEO]: onOpenAiVideoBackgroundModalSequential,
  },
};

/** Poster defaults / add-item bar: every pick REPLACES the page's active background. */
const SET_BACKGROUND_OPENERS: BackgroundSourceOpeners = {
  uploads: onOpenUserBackgroundUploadsModal,
  stock: openStockBackgroundAllMediaPicker,
  ai: {
    [MediaSourceGroup.IMAGE]: onOpenAiImageBackgroundModal,
    [MediaSourceGroup.VIDEO]: onOpenAiVideoBackgroundModal,
  },
};

const openBackgroundSource = (openers: BackgroundSourceOpeners, leaf: MediaSourceLeaf): void => {
  switch (leaf.kind) {
    case MediaSourceKind.UPLOADS:
      openers.uploads();
      return;
    case MediaSourceKind.STOCK:
      openers.stock();
      return;
    case MediaSourceKind.AI:
      if (leaf.group === null) {
        throw new Error('an AI pick always names a media group — each generator produces one type');
      }
      openers.ai[leaf.group]();
      return;
    default:
      assertNever(leaf.kind);
  }
};

const TIMELINE_MEDIA_ADD_OPTION_FOR_SOURCE_KIND: Record<MediaSourceKind, TimelineMediaAddOption> = {
  [MediaSourceKind.UPLOADS]: TimelineMediaAddOption.UPLOADS,
  [MediaSourceKind.STOCK]: TimelineMediaAddOption.STOCK,
  [MediaSourceKind.AI]: TimelineMediaAddOption.AI,
};

/**
 * The one place a picked leaf turns into an open picker. Intent is required and has no default:
 * routing an append to the replace path would silently overwrite the user's background instead of
 * adding one, so the caller must always say which write it means.
 */
export const openMediaSource = (request: MediaSourceRequest): void => {
  switch (request.intent) {
    case MediaSourceIntent.APPEND_BACKGROUND:
      trackTimelineMediaAdded(TimelineItemType.BACKGROUND, TIMELINE_MEDIA_ADD_OPTION_FOR_SOURCE_KIND[request.leaf.kind]);
      openBackgroundSource(APPEND_BACKGROUND_OPENERS, request.leaf);
      return;
    case MediaSourceIntent.SET_BACKGROUND:
      openBackgroundSource(SET_BACKGROUND_OPENERS, request.leaf);
      return;
    case MediaSourceIntent.REPLACE_BACKGROUND:
      openBackgroundReplaceSource(request.selection);
      return;
    case MediaSourceIntent.REPLACE_ITEM:
      openItemReplaceSource(request.selection, request.item, request.onReplace);
      return;
    default:
      assertNever(request);
  }
};

export const onOpenMaskingModal = async (item: ImageItem | ImageSlideItem): Promise<void> => {
  const image = await loadImageAsync(await item.getImageUrl());
  const imageUrl = (await item.refinement.applyRefinementToImage(image)).src;

  const maskingModalCallback = (maskingObjects: MaskingObject[]): void => {
    trackPosterBuilderGA4Events(GA4EventName.MASK_APPLIED, {[GA4EventParamName.TYPE]: maskingObjects[0]?.type});
    void item.updateMasking(maskingObjects[0] ?? null);
  };

  // TODO: This code logic needs to be better; Right now the masking modal doesn't handle a different size image url too
  const removeBGCallback = async (isBackgroundRemoved: boolean, replaceImageCallback: (url: string) => void): Promise<boolean> => {
    if (isBackgroundRemoved) {
      const sourceImageURL = await item.getImageUrl();
      replaceImageCallback(await item.refinement.getRefinedImageUrl(sourceImageURL));
      return false;
    }
    const removedBGURL = await item.removeBackground.getBackgroundRemovedURLForCurrentImageURL();
    if (await doesPublicFileExistAsync(removedBGURL)) {
      replaceImageCallback(await item.refinement.getRefinedImageUrl(removedBGURL));
    } else {
      try {
        showLoading('removing-background-masking-panel');
        await item.removeBackground.removeBackground();
        replaceImageCallback(await item.refinement.getRefinedImageUrl(removedBGURL));
      } catch (e) {
        return false;
      } finally {
        hideLoading('removing-background-masking-panel');
      }
    }

    return true;
  };

  openMaskingModal({
    onMaskCTA: maskingModalCallback,
    initialMaskingData: item.masking.maskingItem?.toObject(),
    imageUrl,
    cropData: item.cropData.isCropped() ? item.cropData.getScaledCropData(image) : undefined,
    removeBackgroundCallback: doesSupportRemoveBackground(item.imageSource) ? removeBGCallback : undefined,
    isBackgroundRemoved: item.removeBackground.isBackgroundRemoved,
  });
};

export const openColorBackgroundPanel = (bgType: BACKGROUND_TYPE): void => {
  const currentPage = window.posterEditor?.whiteboard?.getCurrentPage();
  if (!currentPage) {
    throw new Error(`Current page does not exist`);
  }
  const bgBeingEdited = currentPage.items.getBackgroundBeingEdited();

  let primaryColor = DEFAULT_BACKGROUND_COLOR;
  let secondaryColor = '';
  let gradientType = GRADIENT_TYPE.LINEAR;

  if (isColorBackground(bgBeingEdited)) {
    const {fillType, fillColor: fillColors} = convertFabricColorToFillObject(bgBeingEdited.getFillObject());
    if (fillType === FillTypes.SOLID && fillColors[0]) {
      primaryColor = rgbaToHex(fillColors[0], false);
    }

    if (fillType === FillTypes.LINEAR_GRADIENT || fillType === FillTypes.RADIAL_GRADIENT) {
      if (fillColors[0]) {
        primaryColor = rgbaToHex(fillColors[0], false);
      }
      if (fillColors[1]) {
        secondaryColor = rgbaToHex(fillColors[1], false);
      }
      if (fillType === FillTypes.RADIAL_GRADIENT) {
        gradientType = GRADIENT_TYPE.RADIAL;
      }
    }
  }

  const getNewFillTypeFromObj = (obj: BackgroundColorType): FillTypes => {
    if (obj.backgroundType === BACKGROUND_TYPE.GRADIENT) {
      if (obj.gradientType === GRADIENT_TYPE.LINEAR) {
        return FillTypes.LINEAR_GRADIENT;
      }
      return FillTypes.RADIAL_GRADIENT;
    }

    return FillTypes.SOLID;
  };

  const getNewFillColorFromObj = (obj: BackgroundColorType): RGBA[] => {
    const newFillType = getNewFillTypeFromObj(obj);
    switch (newFillType) {
      case FillTypes.SOLID:
        return [hexToRgba(obj.primaryColor)];
      case FillTypes.LINEAR_GRADIENT:
      case FillTypes.RADIAL_GRADIENT:
        return [hexToRgba(obj.primaryColor), hexToRgba(obj.secondaryColor)];
      default:
        throw new Error(`expected fill type to be solid or gradient`);
    }
  };

  const onApplyBackground = (obj: BackgroundColorType): void => {
    const fillType = getNewFillTypeFromObj(obj);
    const fillColors = getNewFillColorFromObj(obj);
    const bg = currentPage.items.getBackgroundBeingEdited();
    if (bg?.gitype === ITEM_TYPE.RECTANGLE) {
      void bg.updateFromObject({fill: buildFabricFillForBackground(currentPage, fillType, fillColors)});
      return;
    }
    void currentPage.items.replaceActiveBackground(buildColorBackgroundItemObject(currentPage, fillType, fillColors));
  };

  openColorBackgroundModal({
    primaryColor,
    secondaryColor: bgType === BACKGROUND_TYPE.GRADIENT && secondaryColor === '' ? lightenDarkenColor(hexToRgba(primaryColor), 100) : secondaryColor,
    onApplyChanges: onApplyBackground,
    bgType,
    gradientType,
  });
};

export const triggerBuyMoreCredits = (
  params: BuyMoreCreditsParams = {
    headingText: '',
    modalTitle: '',
    cb: (): void => {},
  }
): void => {
  const creditPurchaseCallBack = (data: BuyCreditsResponse): void => {
    params.cb(data.credits);
  };

  openCheckoutForCreditPackPurchase({
    headingText: params.headingText ?? '',
    modalTitle: params.modalTitle ?? '',
    onSuccess: creditPurchaseCallBack,
  });
};

export const openPreviewThumbnailSelectionModalOnSubmit = (): void => {
  const posterHashedId = window.posterEditor?.whiteboard?.hashedID ?? '';

  const onSubmitCallback = (): void => {
    void window.posterEditor?.whiteboard?.savePoster.save();
  };
  openMultipagePreviewThumbnailSelectionModal({posterHashedId, onSubmit: onSubmitCallback});
};
